<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="versions-modal">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-history"></i>
                        版管理
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" v-show="version.id">
                    <div class="row">
                        <div class="col-md-6 py-2 d-flex justify-content-center">
                            <div class="version-title">
                                <span v-if="version.version_name">{{version.version_name}}</span>
                                <span v-else-if="version.id">{{$filters.dateFormat(version.created_at, 'YYYY-MM-DD HH:mm')}}の版</span>
                                <span v-else>
                                    過去の版を <i class="fas fa-code-branch"></i> から選択してください
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 py-2 d-flex justify-content-center">
                            <div class="version-title d-none d-md-block">現在の版</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 outline">
                            <diff
                                mode="split"
                                :theme="theme"
                                :current="episode.body"
                                :prev="version.body || ''"></diff>
                            <div id="mergely"></div>
                        </div>
                    </div>
                    <div class="row" v-if="isSameAs">
                        <div class="col-md-12">
                            <div class="alert alert-warning">
                                同一の本文です。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-primary" v-if="version.id" @click="revert()" :disabled="isSameAs">
                        <i class="fas fa-history"></i>
                        この版を復元
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.version-title {
    font-size: 1.1rem;
}
.outline {
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display:none;
    }
}
</style>
<style lang="scss">
// 子に強制適用のため、scopedしていません
.d2h-code-line-ctn {
    white-space: normal;
}
.d2h-wrapper {
    min-width: 680px;
}
</style>

<script>
export default {
    props: {
        version_id: {
            default: null,
        }
    },
    data() {
        return {
            episode: {},
            version: {},
        }
    },
    methods: {
        load() {
            this.loadEpisode();
            this.loadVersion();
        },
        loadEpisode() {
            axios.get("/mypage/book/section/get", {params: {id: this.$route.params.id}}).then(res => {
                res.data.body = res.data.section_name + "\n\n" + res.data.body;
                this.episode = res.data;
            }).catch(err => { alert.err(err) });
        },
        loadVersion() {
            if (!this.version_id) return;
            axios.get("/mypage/book/version/get", {params: {id: this.version_id}}).then(res => {
                res.data.body = res.data.section_name + "\n\n" + res.data.body;
                this.version = res.data;
            }).catch(err => { alert.err(err) });
        },
        selectVersion(id) {
            this.version_id = id;
            setTimeout(() => {this.loadVersion()});
        },
        revert() {
            axios.post("/mypage/book/version/revert", {id: this.version.id}).then(res => {
                alert.msg(res.data);
                $("#versions-modal").modal("hide");
                this.$emit("revert");
            }).catch(err => { alert.err(err.response) });
        },
    },
    computed: {
        isSameAs() {
            return this.episode.body === this.version.body;
        },
        theme() {
            if (this.$store.state.background_color.match(/black|doom|rome|jupiter|space/)) {
                return "dark";
            }
            return "light";
        },
    },
    mounted() {
        $("#versions-modal").on("show.bs.modal", (e) => {
            this.episode = {};
            this.version = {};
            this.load();
        });
    }
}
</script>